<template>
    <div class="addHome">
        <el-row class="header-box">
            <el-col :span="6" class="disflex">
                <el-button type="text" icon="el-icon-arrow-left" class="butCol" @click="toBack()">返回</el-button>

                <div class="title">
                    当前页面：{{ title }}

                    <el-popover placement="bottom" width="400" trigger="click" popper-class="addHomeSetPopover">
                        <div class="disflex">
                            <el-input v-model="title" placeholder=""></el-input> <el-button type="text">取消</el-button
                            ><el-button type="text">修改</el-button>
                        </div>
                        <i slot="reference" class="el-icon-edit"></i>
                    </el-popover>
                </div>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="4" class="left">
                <el-collapse v-model="activeNames" @change="handleChange">
                    <el-collapse-item title="基础组件" name="1">
                        <div class="items">
                            <div class="item" v-for="i in basicList" :key="i.id" @click="addComponent(i)">
                                <i class="el-icon-picture"></i>
                                <p>{{ i.title }}</p>
                            </div>
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </el-col>
            <el-col :span="18">
                <div class="phone-box">
                    <div class="headerImg">
                        <img src="@/assets/img/header-icon.png" alt="" />
                    </div>
                    <div class="topIcon">首页</div>

                    <div class="overflowy">
                        <div class="phone-content">
                            <div v-for="(item, index) in compList" :key="index">
                                <!-- 轮播组件 -->
                                <component
                                    :is="item"
                                    @remove="remove(index)"
                                    @copy="copy(index)"
                                    @downward="downward(index)"
                                    @upward="upward(index)"
                                    @click="compIndex = index"
                                    :class="compIndex === index ? 'on' : ''"
                                    :index="index"
                                    :finallyIndex="compList.length - 1"
                                    style="margin-bottom: 10px"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="tabbar">
                        <div v-for="(item, index) in tabbarList" :key="index">
                            <img
                                class="img"
                                :class="{ setTabImg: index === 4 }"
                                :src="require(`@/assets/img/tabbar/tabbar${index + 1}.png`)"
                                alt=""
                            />
                            {{ item }}
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import listGroup from './components/list-group.vue'; // 轮播组件
import navigationGroup from './components/navigation-group.vue'; // 导航组组件
import seasonalGroup from './components/seasonal-group.vue'; // 限时秒杀组件
import buyingGroup from './components/buying-group.vue'; // 限时秒杀组件
import productListGroup from './components/product-list-group.vue'; // 商品列表组件
import mustBuyListGroup from './components/must-buy-list-group.vue'; // 必买清单组件
import searchGroup from './components/search-group.vue'; // 搜索组件
export default {
    components: {
        listGroup,
        navigationGroup,
        seasonalGroup,
        buyingGroup,
        productListGroup,
        mustBuyListGroup,
        searchGroup
    },
    data() {
        return {
            compIndex: null,
            title: '111',
            activeNames: '1',
            basicList: [
                { id: 1, title: '轮播图', comp: 'listGroup' },
                { id: 2, title: '导航组', comp: 'navigationGroup' },
                { id: 3, title: '限时秒杀', comp: 'seasonalGroup' },
                { id: 4, title: '精品团购', comp: 'buyingGroup' },
                { id: 5, title: '商品列表', comp: 'productListGroup' },
                { id: 6, title: '必买清单', comp: 'mustBuyListGroup' },
                { id: 7, title: '搜索框', comp: 'searchGroup' }
            ],
            compList: [],
            tabbarList: ['首页', '分类', '购物车', '我的']
        };
    },
    methods: {
        handleChange(val) {},
        // 新增组件
        addComponent(i) {
            this.compList.push(i.comp);
            this.compIndex = this.compList.length - 1;
        },

        // 删除组件
        remove(index) {
            this.compList.splice(index, 1);
            this.compIndex = null;
        },

        downward(index) {
            console.log(index, '向上');
            if (index <= 0) return;
            [this.compList[index], this.compList[index - 1]] = [this.compList[index - 1], this.compList[index]];
            this.compIndex = index - 1;
            this.$forceUpdate();
        },
        upward(index) {
            console.log(index, '向下');
            if (index >= this.compList.length - 1) return;
            [this.compList[index], this.compList[index + 1]] = [this.compList[index + 1], this.compList[index]];
            this.compIndex = index + 1;
            this.$forceUpdate();
        },

        // 复制组件
        copy(index) {
            this.compList.push(this.compList[index]);
            this.compIndex = this.compList.length - 1;
        },

        toBack() {
            this.$router.go(-1);
        }
    }
};
</script>

<style lang="scss" scoped>
.addHome {
    position: fixed;
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 0;
    background: #ececec;
    z-index: 9999;

    .disflex {
        display: flex;
        align-items: center;
    }

    .header-box {
        width: 100%;
        background: #0256ff;
        padding: 16px;
        font-size: 15px;
        color: #fff;
        .butCol {
            color: #fff;
            font-size: 15px;
            position: relative;
            &::before {
                content: '';
                position: absolute;
                right: -20px;
                width: 1px;
                height: 60%;
                background: #ccc;
                top: 20%;
            }
        }

        .title {
            margin-left: 40px;
            margin-bottom: 2px;
        }
    }

    .left {
        padding: 0 30px;
        background: #fff;
        height: calc(100vh - 67px);

        .items {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            padding: 20px 10px;
            gap: 10px; /* 设置网格之间的间隔 */

            .item {
                display: flex;
                flex-direction: column;
                align-items: center;
                padding: 10px;
                cursor: pointer;

                i {
                    font-size: 20px;
                }
                p {
                    margin-top: 10px;
                    font-size: 12px;
                    color: rgb(102, 102, 102);
                }
            }

            .item:hover {
                box-shadow: rgba(24, 144, 255, 0.3) 0px 0px 5px 0px;
                border-right: 5px;
                transform: scale(1.1);
                transition: 0.2s;
            }
        }
    }

    .overflowy {
        overflow-y: auto;
        // padding-left: 15px;
    }

    .overflowy::-webkit-scrollbar {
        width: 0;
    }

    .phone-box {
        margin-top: 30px;

        .phone-content {
            width: 375px;
            height: 650px;
            width: 375px;
            margin: auto;
            // overflow-x: hidden;
            padding-top: 10px;
            background: #fff;
        }

        .topIcon {
            position: relative;
            height: 35px;
            line-height: 35px;
            background: #fff;
            font-size: 15px;
            color: #333;
            text-align: center;
            width: 375px;
            margin: 0 auto;
            width: 375px;
            margin: auto;
        }

        .headerImg {
            width: 375px;
            margin: auto;
            background: #fff;
            text-align: center;
            & > img {
                width: 100%;
            }
        }

        .tabbar {
            width: 375px;
            margin: auto;
            height: 44px;
            display: grid;
            background: #fff;
            font-size: 12px;
            color: #333;
            grid-template-columns: repeat(4, 1fr); /* 创建四个等宽的列 */
            gap: 10px; /* 可选，设置列与列之间的间隙 */
            & > div {
                text-align: center;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                .img {
                    width: 20px;
                    margin-bottom: 4px;
                }

                .setTabImg {
                    width: 16px;
                }
            }

            & > div:first-child {
                color: red;
            }
        }
    }
}
</style>
<style>
.addHomeSetPopover {
    z-index: 10000 !important;
}
</style>